import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "services", "recyclableCollectionUnity", "recyclableMinimumAmount", "organicCollectionUnity", "organicMinimumAmount", "wasteCollectionUnity", "wasteMinimumAmount", "electronicCollectionUnity", "electronicMinimumAmount" ]

  connect() {

    if (document.body.getAttribute("data-action").includes("new") || document.body.getAttribute("data-action").includes("create") || document.body.getAttribute("data-action").includes("edit") || document.body.getAttribute("data-action").includes("update")) {
      var cleave = new Cleave('.input-date', {
        date: true,
        datePattern: ['m', 'Y']
      })
    }

    if (document.body.getAttribute("data-action").includes("edit") || document.body.getAttribute("data-action").includes("update")) {
      var recyclableCollectionUnityTarget = this.recyclableCollectionUnityTarget
      var recyclableMinimumAmountTarget = this.recyclableMinimumAmountTarget
      var organicCollectionUnityTarget = this.organicCollectionUnityTarget
      var organicMinimumAmountTarget = this.organicMinimumAmountTarget
      var wasteCollectionUnityTarget = this.wasteCollectionUnityTarget
      var wasteMinimumAmountTarget = this.wasteMinimumAmountTarget
      var electronicCollectionUnityTarget = this.electronicCollectionUnityTarget
      var electronicMinimumAmountTarget = this.electronicMinimumAmountTarget

      recyclableCollectionUnityTarget.textContent = "(-)"
      recyclableMinimumAmountTarget.textContent = "(-)"
      organicCollectionUnityTarget.textContent = "(-)"
      organicMinimumAmountTarget.textContent = "(-)"
      wasteCollectionUnityTarget.textContent = "(-)"
      wasteMinimumAmountTarget.textContent = "(-)"
      electronicCollectionUnityTarget.textContent = "(-)"
      electronicMinimumAmountTarget.textContent = "(-)"
      if (this.servicesTarget.value == "") {
      } else {
        fetch("/itens-de-servicos/" + this.servicesTarget.value).then(
          function(response) {
            return response.json().then(function(json) {
              for (var i = 0; i < json.length; i++) {
                switch (json[i].residue_type) {
                  case "Rejeitos":
                    wasteCollectionUnityTarget.textContent = json[i].collection_unity
                    wasteMinimumAmountTarget.textContent = json[i].minimum_amount
                    continue
                  case "Orgânicos":
                    organicCollectionUnityTarget.textContent = json[i].collection_unity
                    organicMinimumAmountTarget.textContent = json[i].minimum_amount
                    continue
                  case "Recicláveis":
                    recyclableCollectionUnityTarget.textContent = json[i].collection_unity
                    recyclableMinimumAmountTarget.textContent = json[i].minimum_amount
                    continue
                  case "Eletroeletrônicos":
                    electronicCollectionUnityTarget.textContent = json[i].collection_unity
                    electronicMinimumAmountTarget.textContent = json[i].minimum_amount
                    continue
                }
              }
            })
          }
        )
      }
    }
  }

  // Change customer and return services
  changeCustomer(event) {
    var servicesTarget = this.servicesTarget
    this.recyclableCollectionUnityTarget.textContent = "(-)"
    this.recyclableMinimumAmountTarget.textContent = "(-)"
    this.organicCollectionUnityTarget.textContent = "(-)"
    this.organicMinimumAmountTarget.textContent = "(-)"
    this.wasteCollectionUnityTarget.textContent = "(-)"
    this.wasteMinimumAmountTarget.textContent = "(-)"
    this.electronicCollectionUnityTarget.textContent = "(-)"
    this.electronicMinimumAmountTarget.textContent = "(-)"
    if (event.currentTarget.value == "") {
      servicesTarget.options.length = 1
    } else {
      fetch("/servicos/" + event.currentTarget.value).then(
        function(response) {
          return response.json().then(function(json) {
            servicesTarget.options.length = 1
            for (var i = 0; i < json.length; i++) {
              var option = document.createElement("option")
              option.appendChild(document.createTextNode(json[i]["name"]))
              option.value = json[i]["_id"]["$oid"]
              servicesTarget.appendChild(option)
            }
          })
        }
      )
    }
  }

  // Change customer and return services
  changeService(event) {
    var recyclableCollectionUnityTarget = this.recyclableCollectionUnityTarget
    var recyclableMinimumAmountTarget = this.recyclableMinimumAmountTarget
    var organicCollectionUnityTarget = this.organicCollectionUnityTarget
    var organicMinimumAmountTarget = this.organicMinimumAmountTarget
    var wasteCollectionUnityTarget = this.wasteCollectionUnityTarget
    var wasteMinimumAmountTarget = this.wasteMinimumAmountTarget
    var electronicCollectionUnityTarget = this.electronicCollectionUnityTarget
    var electronicMinimumAmountTarget = this.electronicMinimumAmountTarget

    recyclableCollectionUnityTarget.textContent = "(-)"
    recyclableMinimumAmountTarget.textContent = "(-)"
    organicCollectionUnityTarget.textContent = "(-)"
    organicMinimumAmountTarget.textContent = "(-)"
    wasteCollectionUnityTarget.textContent = "(-)"
    wasteMinimumAmountTarget.textContent = "(-)"
    electronicCollectionUnityTarget.textContent = "(-)"
    electronicMinimumAmountTarget.textContent = "(-)"
    if (event.currentTarget.value == "") {
    } else {
      fetch("/itens-de-servicos/" + event.currentTarget.value).then(
        function(response) {
          return response.json().then(function(json) {
            for (var i = 0; i < json.length; i++) {
              switch (json[i].residue_type) {
                case "Rejeitos":
                  wasteCollectionUnityTarget.textContent = json[i].collection_unity
                  wasteMinimumAmountTarget.textContent = json[i].minimum_amount
                  continue
                case "Orgânicos":
                  organicCollectionUnityTarget.textContent = json[i].collection_unity
                  organicMinimumAmountTarget.textContent = json[i].minimum_amount
                  continue
                case "Recicláveis":
                  recyclableCollectionUnityTarget.textContent = json[i].collection_unity
                  recyclableMinimumAmountTarget.textContent = json[i].minimum_amount
                  continue
                case "Eletroeletrônicos":
                  electronicCollectionUnityTarget.textContent = json[i].collection_unity
                  electronicMinimumAmountTarget.textContent = json[i].minimum_amount
                  continue
              }
            }
          })
        }
      )
    }
  }
}
